import { PROCESS_NODE_TYPES } from './process'

/**
 * 默认的提示语
 */
const createDefaultStatusTips = ({
  fristWriteTips = '暂未填写',
  fristWriteBtnText = '去填写',
  secondWriteTips = '你可以在 {stepEndDateStr} 前继续编辑',
  secondWriteBtnText = '编辑',
  checkedAndNotEditTips = '此环节已被确认，无需再进行编辑',
  stepOverTimeLimitStatusTips = '当前环节已逾期，仅剩一次编辑机会，请谨慎操作',
  secondEndTips = '该环节已在 {stepEndDateStr} 结束',
  unAssessSlefTips = '您无法为自己编辑此评估内容'
} = {}) => ({
  fristWriteTips,
  secondWriteTips,
  fristWriteBtnText,
  secondWriteBtnText,
  checkedAndNotEditTips,
  stepOverTimeLimitStatusTips,
  secondEndTips,
  unAssessSlefTips
})


/**
 * 每个环节的一些默认状态提示
 */
export const DEFAULT_STEP_CONFIGS = {
  // 评估型环节
  [PROCESS_NODE_TYPES.START_ASSESS.stepType]: {
    ...createDefaultStatusTips({ checkedAndNotEditTips: '此评估已被校准，无需再进行编辑' })
  },
  // 目标制定环节
  [PROCESS_NODE_TYPES.GOAL_SETTING.stepType]: {
    ...createDefaultStatusTips()
  },
  // 360邀请环节
  [PROCESS_NODE_TYPES.ANNULAR_INVITE.stepType]: {
    ...createDefaultStatusTips({ fristWriteBtnText: '去邀请', fristWriteTips: '暂未邀请' })
  },
  // 360确认环节
  [PROCESS_NODE_TYPES.ANNULAR_IDENTIFY.stepType]: {
    ...createDefaultStatusTips({ fristWriteBtnText: '去确认', fristWriteTips: '暂未确认',  unAssessSlefTips: '您只能查看邀请结果，无法进行确认'   })
  },
  // 绩效校准环节
  [PROCESS_NODE_TYPES.CALIBRATION.stepType]: {
    ...createDefaultStatusTips({ fristWriteBtnText: '去校准', fristWriteTips: '暂未校准', unAssessSlefTips: '您只能查看绩效结果信息，无法进行校准'  })
  },
  // 绩效查看环节
  [PROCESS_NODE_TYPES.START_VIEW.stepType]: {
    ...createDefaultStatusTips()
  },
  // 结果沟通环节
  [PROCESS_NODE_TYPES.COMMUNICATION_RESULT.stepType]: {
    ...createDefaultStatusTips()
  },
  // 结果复议环节
  [PROCESS_NODE_TYPES.RESULT_REVIEW.stepType]: {
    ...createDefaultStatusTips({ fristWriteBtnText: '去处理', fristWriteTips: '暂未处理',  unAssessSlefTips: '您只能查看评估结果，无法进行复议处理'})
  }
}


export const STATUS_MAP_COLOR_CONFIG = {
  DefaultTipsColorConfig: {
    background: '#FFFDFC',
    border: '#FFD1BA',
  },
  FailTipsColorConfig: {
    background: '#FFF5F6',
    border: '#FAAFB8',
  },
  SuccessTipsColorConfig: {
    background: '#F5FAF7',
    border: '#ABE0C2',
  },
  BeoverColorConfig: {
    background: '#f3f4f5',
    border: '#f3f4f5',
  }
}